import React from "react";
import PropTypes from "prop-types";
import styles from "./UserItem.module.css";
import Button from "shared/Button";
import { Link } from "react-router-dom";

/**
 * Interactive component. Displays information about a user in the users list.
 */

export function UserItem({ eventMemberInfo, onClick }) {
  return (
    <div className={styles.gridContainer}>
      <div className={(styles.gridItem, styles.name)}>
        <Link to="/dreamstream/user/details">
          {eventMemberInfo.iboInfo.name}
        </Link>
      </div>
      <div className={styles.gridItem}>{eventMemberInfo.iboNumber}</div>
      {/* <div className={styles.gridItem}>{eventMemberInfo.dsID}</div> */}
      <div className={styles.gridItem}>{eventMemberInfo.loa.pinLevel}</div>
      <div className={styles.gridItem}>
        {eventMemberInfo.isActive ? "Active" : "InActive"}
      </div>

      <Button
        className={styles.button}
        onClick={onClick}
        size="tiny"
        children="Details"
      />
    </div>
  );
}

UserItem.propTypes = {
  /**
   * Object with the members info.
   */
  eventMemberInfo: PropTypes.shape({
    name: PropTypes.string,
    iboNum: PropTypes.string,
    dsID: PropTypes.string,
    pin: PropTypes.string,
    status: PropTypes.bool,
  }),

  /**
   * 	Function called when details is clicked
   */
  onClick: PropTypes.func,
};
